import { DetailedHTMLProps, FormHTMLAttributes, memo, useMemo } from 'react';

import { Loading } from '@/components/core';
import { TableField } from '@/components/ui';
import { useDocumentStore, useValidationStore } from '@/store';

export type DocumentTableFormProps = DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>;

const IDocumentTableForm = ({}: DocumentTableFormProps) => {
  const fieldConfig = useDocumentStore((state) => state.fieldConfig);
  const status = useDocumentStore((state) => state.status);

  const currentTable = useValidationStore((state) => state.currentTable);

  const currentLabel = useMemo(() => {
    return Object.keys(fieldConfig ?? {}).find((label) => fieldConfig?.[label] === currentTable?.field);
  }, [currentTable?.field, fieldConfig]);

  if (status === 'pending-predictions') {
    return <Loading label="AI is working" message="The AI model is parsing your document" />;
  }

  if (!currentLabel) {
    return null;
  }

  return <TableField key={currentLabel} rowId={currentLabel} name={currentLabel} />;
};

export const DocumentTableForm = memo(IDocumentTableForm) as typeof IDocumentTableForm;
